import { FC, SVGProps } from 'react';

export const CardIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6 6.25C4.48122 6.25 3.25 7.48122 3.25 9V12V22C3.25 23.5188 4.48122 24.75 6 24.75H26C27.5188 24.75 28.75 23.5188 28.75 22V12V9C28.75 7.48122 27.5188 6.25 26 6.25H6ZM4.75 9C4.75 8.30964 5.30964 7.75 6 7.75H26C26.6904 7.75 27.25 8.30964 27.25 9V11.25H4.75V9ZM4.75 12.75H27.25V22C27.25 22.6904 26.6904 23.25 26 23.25H6C5.30964 23.25 4.75 22.6904 4.75 22V12.75ZM8 18.75C7.58579 18.75 7.25 19.0858 7.25 19.5C7.25 19.9142 7.58579 20.25 8 20.25H13.5C13.9142 20.25 14.25 19.9142 14.25 19.5C14.25 19.0858 13.9142 18.75 13.5 18.75H8Z"
			fill="currentColor"
		/>
	</svg>
);
